module.exports = __webpack_public_path__ + "static/media/exukonline-calendar-icon.c71ea34f.png";